import { VehicleInfo } from "Store/findVehicle/interfaces";
import { FormikProps } from "formik";
import { CarProductIntroFormValues } from "../interfaces";

export function setVehicle(
  formProps: FormikProps<CarProductIntroFormValues>,
  vehicle: VehicleInfo,
): void {
  formProps.setFieldValue("licensePlateNumber", vehicle.regNumber);
  formProps.setFieldValue("configurationId", vehicle.configurationId);
  formProps.setFieldValue("year", vehicle.registrationYear);
  formProps.setFieldValue("brand", vehicle.brand);
  formProps.setFieldValue("model", vehicle.model);
  formProps.setFieldValue("modelType", vehicle.configurationId);
  formProps.setFieldValue("kw", vehicle.kw);
  formProps.setFieldValue("volume", vehicle.volume);
  formProps.setFieldValue("canBeBoughtOnline", vehicle.canBeBoughtOnline);
  formProps.setFieldValue("warrantyType", vehicle.warrantyType);
  formProps.setFieldValue("tfaCode", vehicle.tfaCode);
}
